import { isIOSApp, IOS_SUBSCRIPTION_NOTE } from "../../utils/platform";

const reasonTexts = {
    pending: 'Your account is pending approval. You can add one-way availability once your account is approved.',
    rejected: 'Your account has been rejected. Please contact Cars53 support for help.',
    expired: 'You do not have an active subscription. Please renew your subscription to add one-way availability.',
};

// Maps the one-way eligibility response to the modal shown to the vendor, or null when they can add availability.
const getAvailabilityBlocker = (eligibility) => {
    if (!eligibility.eligible) {
        return {
            title: eligibility.message,
            text: eligibility.reason === 'expired' && isIOSApp() ? IOS_SUBSCRIPTION_NOTE : reasonTexts[eligibility.reason],
            ...(eligibility.reason === 'expired' && !isIOSApp() && { actionLabel: 'Renew Subscription', actionTo: '/subscriptions/add' }),
        };
    }
    if (!eligibility.hasCar) {
        return {
            title: 'Add your car first',
            text: 'Please add your car first before creating a one-way availability.',
            actionLabel: 'Add Car',
            actionTo: '/addcar',
        };
    }
    return null;
};

export default getAvailabilityBlocker;
